import { Table, TableColumn, Typography } from '@scale/scaleui';
import { LoadingTable } from './LoadingTable';

const WorkerSkillEntriesColumns: TableColumn[] = [
  {
    id: 'name',
    header: 'Name',
    cell: function NameCell(props: any) {
      return (
        <div className="flex flex-col">
          <Typography.Paragraph2>{props.row.original.name}</Typography.Paragraph2>
          <div className="text-xs">{props.row.original.workerSkill}</div>
        </div>
      );
    },
  },
  {
    id: 'overallScore',
    header: 'Overall Score',
  },
  {
    id: 'ratingScore',
    header: 'Rating Score',
  },
  {
    id: 'ratingStatus',
    header: 'Rating Status',
  },
  {
    id: 'writingScore',
    header: 'Writing Score',
  },
  {
    id: 'writingStatus',
    header: 'Writing Status',
  },
  {
    id: 'editingScore',
    header: 'Editing Score',
  },
  {
    id: 'editingStatus',
    header: 'Editing Status',
  },
];

interface WorkerSkillEntriesTableProps {
  title?: string;
  data: object[] | null;
  isLoading: boolean;
}

export const WorkerSkillEntriesTable: React.FC<WorkerSkillEntriesTableProps> = ({
  title = 'Worker Skill Entries',
  data,
  isLoading,
}: WorkerSkillEntriesTableProps) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <Typography.Subtitle2>{title}</Typography.Subtitle2>
      </div>
      {isLoading ? (
        <LoadingTable columns={WorkerSkillEntriesColumns} numRows={1} rowHeight={1} />
      ) : (
        <Table columns={WorkerSkillEntriesColumns} data={data || []} />
      )}
    </div>
  );
};
